export default __webpack_public_path__ + "assets/models/3fdfef1a51b75d8169e1703f9d2373da.glb";